import { render, staticRenderFns } from "./CouponImport.vue?vue&type=template&id=10842d48&"
import script from "./CouponImport.vue?vue&type=script&lang=js&"
export * from "./CouponImport.vue?vue&type=script&lang=js&"
import style0 from "./CouponImport.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CouponImport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports